import styled, { css } from 'styled-components'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

export const SearchButton = styled.button`
  ${styleReset}
  font-size: 2rem;
  cursor: pointer;

  svg {
    display: block;
    margin: 0.4rem 0;
  }
`

export const Input = styled.input`
  ${styleReset}
  width: 0;
  padding: 1rem 0;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0);
  color: white !important;
  color-scheme: dark;

  &:hover,
  &:focus {
    background-color: rgb(51, 51, 51);
    border-color: rgba(255, 255, 255, 0.8);
    outline: none;
  }
`

export const Form = styled.form<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  margin: 0 auto 0 1.5rem;
  padding-left: 1.5rem;
  border-left: 1px solid rgba(255, 255, 255, 0.2);

  ${props =>
    props.isOpen &&
    css`
      ${Input} {
        width: 12rem;
        padding: 1rem 4rem 1rem 1rem;
        margin-right: -3rem;
        border-color: rgba(0, 0, 0, 0.4);
        color: black;

        ${mq.medium} {
          border-color: rgba(255, 255, 255, 0.4);
          width: 25rem;
          color: white;
        }
      }
    `}
`
